import { PageHeader } from '@@/PageHeader';

import { PoliciesDatatable } from './PoliciesDatatable/PoliciesDatatable';

export function ListView() {
  return (
    <>
      <PageHeader
        title="Policies"
        breadcrumbs="Fleet Governance Policies"
        reload
      />

      <PoliciesDatatable />
    </>
  );
}
